import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/base/SEOHead';
import SchemaOrg from '@/components/base/SchemaOrg';
import ScrollToTop from '@/components/base/ScrollToTop';
import { categories, categoryFAQs } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

const categoryImages: Record<string, string> = {
  chengrengaokao: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20education%20exam%20concept%20with%20warm%20lighting%2C%20soft%20cream%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=800&height=400&seq=cat-gaokao&orientation=landscape',
  zixuekaoshi: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20self%20study%20education%20concept%20with%20minimalist%20books%20and%20warm%20lighting%2C%20soft%20beige%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=800&height=400&seq=cat-zixue&orientation=landscape',
  wangluojiaoyu: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20online%20learning%20concept%20with%20laptop%20and%20warm%20lighting%2C%20soft%20cream%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=800&height=400&seq=cat-wangluo&orientation=landscape',
  guojiakaifang: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20university%20campus%20education%20concept%20with%20warm%20lighting%2C%20soft%20beige%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=800&height=400&seq=cat-guokai&orientation=landscape',
};

const articleThumbnails: Record<string, string> = {
  'article-chengrengaokao': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20education%20learning%20concept%20with%20minimalist%20books%20and%20warm%20lighting%2C%20soft%20gradient%20background%20in%20cream%20and%20warm%20beige%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-chengrengaokao&orientation=landscape',
  'article-zixuekaoshi': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20self%20study%20education%20concept%20with%20neat%20desk%20and%20warm%20lighting%2C%20soft%20cream%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-zixuekaoshi&orientation=landscape',
  'article-wangluojiaoyu': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20online%20learning%20concept%20with%20laptop%20and%20warm%20lighting%2C%20soft%20beige%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-wangluojiaoyu&orientation=landscape',
  'article-guokaida': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20university%20education%20concept%20with%20minimalist%20composition%20and%20warm%20lighting%2C%20soft%20cream%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-guokaida&orientation=landscape',
  'article-beikao': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20exam%20preparation%20concept%20with%20notebooks%20and%20warm%20lighting%2C%20soft%20cream%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-beikao&orientation=landscape',
  'article-lunwen': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20thesis%20writing%20concept%20with%20papers%20and%20warm%20lighting%2C%20soft%20beige%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-lunwen&orientation=landscape',
  'article-xiaolv': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20productivity%20learning%20concept%20with%20minimalist%20desk%20setup%20and%20warm%20lighting%2C%20soft%20cream%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-xiaolv&orientation=landscape',
  'article-zhichang': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20career%20development%20concept%20with%20minimalist%20office%20elements%20and%20warm%20lighting%2C%20soft%20beige%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-zhichang&orientation=landscape',
  'article-zhengce': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20education%20policy%20concept%20with%20documents%20and%20warm%20lighting%2C%20soft%20cream%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-zhengce&orientation=landscape',
  'article-tiyan': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20student%20experience%20education%20concept%20with%20warm%20lighting%2C%20soft%20beige%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-tiyan&orientation=landscape',
  'article-shuxue': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20mathematics%20learning%20concept%20with%20formulas%20and%20warm%20lighting%2C%20soft%20cream%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-shuxue&orientation=landscape',
  'article-yingyu': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20English%20language%20learning%20concept%20with%20books%20and%20warm%20lighting%2C%20soft%20beige%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-yingyu&orientation=landscape',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const [activeFaq, setActiveFaq] = useState<number | null>(null);

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <div className="pt-20 text-center py-20">
          <h1 className="font-heading text-2xl text-foreground-900">分类未找到</h1>
          <Link to="/" className="text-primary-600 mt-4 inline-block cursor-pointer">返回首页</Link>
        </div>
        <Footer />
      </div>
    );
  }

  const categoryArticles = articles.filter((a) => a.category === slug);
  const faqs = categoryFAQs[slug as keyof typeof categoryFAQs] || [];

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title={`${category.name} - 成人高清学历提升平台`}
        description={category.description}
        keywords={`${category.name},学历提升,成人教育,在职进修,成人高清`}
        canonicalUrl={`https://www.chengrengaoqing.com/category/${slug}`}
        ogTitle={`${category.name} - 成人高清学历提升平台`}
        ogDescription={category.description}
        ogImage={categoryImages[slug as string]}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${category.name} - 成人高清学历提升平台`,
          description: category.description,
          url: `https://www.chengrengaoqing.com/category/${slug}`,
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: category.name },
            ]}
          />

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-6xl mx-auto">
              <div className="flex flex-col lg:flex-row gap-8">
                <div className="lg:w-64 shrink-0">
                  <div className="sticky top-24">
                    <h3 className="font-heading text-base text-foreground-900 mb-3">学历提升方式</h3>
                    <div className="flex flex-col gap-1">
                      {categories.map((cat) => (
                        <Link
                          key={cat.slug}
                          to={`/category/${cat.slug}`}
                          className={`flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap ${
                            cat.slug === slug
                              ? 'bg-primary-50 text-primary-600 font-medium'
                              : 'text-foreground-600 hover:bg-background-100 hover:text-primary-600'
                          }`}
                        >
                          <i className={`${cat.icon} text-base`}></i>
                          {cat.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="flex-1 min-w-0">
                  <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-8 mb-8">
                    <div className="flex items-center gap-4 mb-4">
                      <div className="w-16 h-16 flex items-center justify-center rounded-xl bg-accent-50 shrink-0">
                        <i className={`${category.icon} text-3xl text-accent-600`}></i>
                      </div>
                      <div>
                        <h1 className="font-heading text-2xl md:text-3xl text-foreground-950">
                          {category.name}
                        </h1>
                        <p className="text-sm text-foreground-500 mt-1">
                          {category.articleCount} 篇文章 · {category.studentCount.toLocaleString()} 名学员
                        </p>
                      </div>
                    </div>
                    <p className="text-foreground-700 leading-relaxed">{category.description}</p>
                    <div className="flex flex-wrap gap-2 mt-5">
                      {category.features.map((f, i) => (
                        <span
                          key={i}
                          className="px-3 py-1 rounded-full text-xs bg-accent-50 text-accent-700 whitespace-nowrap"
                        >
                          {f}
                        </span>
                      ))}
                    </div>
                  </div>

                  <h2 className="font-heading text-xl text-foreground-950 mb-5">相关文章</h2>
                  <div className="flex flex-col gap-4">
                    {categoryArticles.map((article) => (
                      <Link
                        key={article.id}
                        to={`/article/${article.id}`}
                        className="group flex flex-col sm:flex-row gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
                      >
                        <div className="sm:w-48 shrink-0 aspect-[16/10] sm:aspect-auto rounded-lg overflow-hidden">
                          <img
                            src={articleThumbnails[article.imageSeq]}
                            alt={article.title}
                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                            loading="lazy"
                          />
                        </div>
                        <div className="flex-1 min-w-0">
                          <h3 className="font-heading text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                            {article.title}
                          </h3>
                          <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
                            {article.summary}
                          </p>
                          <div className="flex items-center gap-3 text-xs text-foreground-400 flex-wrap">
                            <span>{article.publishDate}</span>
                            <span>·</span>
                            <span className="flex items-center gap-1">
                              <i className="ri-eye-line"></i>
                              {article.readCount.toLocaleString()} 阅读
                            </span>
                            <span>·</span>
                            <span>{article.author}</span>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>

                  {faqs.length > 0 && (
                    <div className="mt-12">
                      <h2 className="font-heading text-xl text-foreground-950 mb-5">常见问题</h2>
                      <div className="flex flex-col gap-2">
                        {faqs.map((faq, i) => (
                          <div
                            key={i}
                            className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
                          >
                            <button
                              onClick={() => setActiveFaq(activeFaq === i ? null : i)}
                              className="w-full px-5 py-3.5 flex items-center justify-between text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                            >
                              <span className="text-sm font-medium text-foreground-900 pr-4">{faq.q}</span>
                              <i
                                className={`ri-arrow-down-s-line text-foreground-400 shrink-0 transition-transform ${
                                  activeFaq === i ? 'rotate-180' : ''
                                }`}
                              ></i>
                            </button>
                            {activeFaq === i && (
                              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                                {faq.a}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}